// extracted by mini-css-extract-plugin
export default {"container":"ProductSelectionListItem_container__vQLLC","productDetails":"ProductSelectionListItem_productDetails__p7l0+"};